import * as React from 'react';
import * as Redux from 'redux';
import { ResultsProps } from '../../state-helpers/site-settings-props';
import { getResultsText } from '../../actions/results-count';

interface IResultsCountMessageProps {
  totalResults: number;
  pageResults: number;
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
  customClasses?: string;
}

export class ResultsCountMessage extends React.Component<IResultsCountMessageProps, any> {
  render() {

    return (
                <div className="loading-status">
            {this.props.isLoading
                ? 
                <div className="search-results-loader">
                    <p className="loading-status-message">Loading Your Results</p>
                    <div className="loader-block"></div>
                </div> 
                : 
                <p className="">{getResultsText(this.props.totalResults,
          this.props.pageResults,
          this.props.pageSize,
          this.props.currentPage)}</p>}
      </div>
    );
  }
}
